import { IImageTile } from "@faire/web-api/indigofair/data/IImageTile";
import { ResponsiveValues } from "@faire/web/slate/Theme/ResponsiveValues";

import { CIRCLE_TILE_WIDTH_PIXELS } from "@faire/retailer/components/SDUI/ComponentRenderers/Tile/sharedStylingConsts";

export const useResponsiveTileWidth = (
  imageTileVariant?: keyof typeof IImageTile.ImageTileVariant
): ResponsiveValues<number> => {
  if (
    imageTileVariant === IImageTile.ImageTileVariant.CIRCLE_TILE ||
    imageTileVariant === IImageTile.ImageTileVariant.SMALL_CIRCLE_TILE
  ) {
    return CIRCLE_TILE_WIDTH_PIXELS;
  }

  return {
    mobileAndAbove: 0,
  };
};
